/* DoodleBeast: small enhancements on every page */
(function () {
  var ICON_GIFT = '<svg viewBox="0 0 28 28" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="10" width="22" height="6"></rect><path d="M5 16v9h18v-9M14 10v15M14 10c-3 0-6-1.5-6-4a2.5 2.5 0 015 0c0 2 1 4 1 4zm0 0c3 0 6-1.5 6-4a2.5 2.5 0 00-5 0c0 2-1 4-1 4z"></path></svg>';
  var ICON_OK = '<svg viewBox="0 0 28 28" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="14" cy="14" r="11"></circle><path d="M8.5 14.5l3.5 3.5 7.5-8"></path></svg>';
  var count = -1, fetching = false, lastFetch = 0, rendering = false;
  function state() { return count >= 2 ? 'ok' : (count === 1 ? 'one' : 'none'); }
  function html() {
    var s = state();
    if (s === 'ok') return '<div class="db-cart-note db-cart-note--ok" data-state="ok">' + ICON_OK + '<span>Top! Je verzending in Nederland is gratis.</span></div>';
    if (s === 'one') return '<div class="db-cart-note" data-state="one">' + ICON_GIFT + '<span>Nog 1 beeld erbij en je verzending in Nederland is gratis.</span></div>';
    return '<div class="db-cart-note" data-state="none">' + ICON_GIFT + '<span>Bestel 2 beelden en de verzending in Nederland is gratis.</span></div>';
  }
  function render() {
    if (rendering) return;
    rendering = true;
    try {
      [document.querySelector('cart-drawer .drawer__footer'), document.querySelector('.cart__footer .cart__blocks')].forEach(function (host) {
        if (!host) return;
        var cur = host.querySelector('.db-cart-note');
        if (cur) { if (cur.getAttribute('data-state') !== state()) cur.outerHTML = html(); }
        else host.insertAdjacentHTML('afterbegin', html());
      });
    } finally { rendering = false; }
  }
  function refresh() {
    var now = Date.now();
    if (fetching || now - lastFetch < 1000) return;
    fetching = true; lastFetch = now;
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      if (c && typeof c.item_count === 'number') count = c.item_count;
    }).catch(function () {}).then(function () { fetching = false; render(); });
  }
  render(); refresh();
  var pending = null;
  new MutationObserver(function (muts) {
    if (rendering) return;
    var mine = muts.every(function (m) { return m.target && m.target.closest && m.target.closest('.db-cart-note'); });
    if (mine) return;
    if (pending) return;
    pending = setTimeout(function () { pending = null; render(); refresh(); }, 400);
  }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.quantity__button, .cart-remove-button, .product-form__submit, .db-sticky__btn')) setTimeout(refresh, 1200); }, true);

  /* muurletters page: shipping line matches the shop rule (page content is shared with the live theme, so it is adjusted here) */
  var ship = document.querySelector('#db-letters .dbl-ship');
  if (ship) ship.innerHTML = '🚚 Verzending in Nederland €5,85 · gratis bij 2 of meer beelden';
})();
